"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLabelPosition = void 0;
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
function getLabelPosition(position, side, labelWidth, windowSize) {
    const screenSize = [windowSize.width, windowSize.height];
    const minDistanceFromPoint = (100 / 1024) * screenSize[0];
    const offset = (screenSize[0] - (screenSize[1] / 3) * 4) / 2;
    let x = position.x * windowSize.width;
    let y = position.y * windowSize.height - minDistanceFromPoint;
    switch (side) {
        case bridge_schema_1.LabelOrientation.Left:
            x -= minDistanceFromPoint + labelWidth;
            break;
        case bridge_schema_1.LabelOrientation.Right:
            x += minDistanceFromPoint;
            break;
        default:
    }
    if (y < 0) {
        y = Math.abs(y);
    }
    x = Math.min(Math.max(offset, x), screenSize[0] - offset);
    return { x: x / screenSize[0], y: y / screenSize[1] };
}
exports.getLabelPosition = getLabelPosition;
